import { lazy } from "react";

export const iconRegistry: Record<string, React.LazyExoticComponent<React.FC>> = {
  "demo-lab": lazy(() => import("@assets/icons/data-lab")),
  "settings": lazy(() => import("@assets/icons/settings")),
  "read-me": lazy(() => import("@assets/icons/read-me")),
  "edit": lazy(() => import("@assets/icons/edit")),
  "info": lazy(() => import("@assets/icons/info")),
  "default": lazy(() => import("@assets/icons/default")),
  "arrow-left": lazy(() => import("@assets/icons/arrow-left")),
  "arrow-right": lazy(() => import("@assets/icons/arrow-right")),
  "chevron-down": lazy(() => import("@assets/icons/chevron-down")),
  "refresh": lazy(() => import("@assets/icons/refresh")),
  "file": lazy(() => import("@assets/icons/file")),
  "check": lazy(() => import("@assets/icons/check")),
  "download": lazy(() => import("@assets/icons/download")),
  "tse-links": lazy(() => import("@assets/icons/tse-links")),
  "key": lazy(() => import("@assets/icons/key")),
  "send": lazy(() => import("@assets/icons/send")),
  "save": lazy(() => import("@assets/icons/save")),
  "internal_reporting": lazy(() => import("@assets/icons/internal-reporting")),
  "tse_for_isv": lazy(() => import("@assets/icons/tse-for-isv")),
  "monetise": lazy(() => import("@assets/icons/monetise")),
  "mockup-lab": lazy(() => import("@assets/icons/mockup-lab")),
  "plus": lazy(() => import("@assets/icons/plus")),
  "bin": lazy(() => import("@assets/icons/bin")),
  "open_url": lazy(() => import("@assets/icons/open_url")),
  "close": lazy(() => import("@assets/icons/close")),
  "close-v2": lazy(() => import("@assets/icons/close-v2")),
  "open": lazy(() => import("@assets/icons/open")),
  "archive": lazy(() => import("@assets/icons/archive")),
  "unarchive": lazy(() => import("@assets/icons/unarchive")),
  "view": lazy(() => import("@assets/icons/view")),
  "generate": lazy(() => import("@assets/icons/generate")),
  "alarm": lazy(() => import("@assets/icons/alarm")),
  "close-small": lazy(() => import("@assets/icons/close-small")),
  "dashboard": lazy(() => import("@assets/icons/dashboard")),
  "my_reports": lazy(() => import("@assets/icons/my_reports")),
  "spotter": lazy(() => import("@assets/icons/spotter")),
  "playground": lazy(() => import("@assets/icons/playground")),
  "integration": lazy(() => import("@assets/icons/integration")),
  "snowflake": lazy(() => import("@assets/icons/snowflake")),
  "databricks": lazy(() => import("@assets/icons/databricks")),
  "thoughtspot": lazy(() => import("@assets/icons/thoughtspot")),
  "delete": lazy(() => import("@assets/icons/delete")),
  "connection": lazy(() => import("@assets/icons/connection")),
  "stack": lazy(() => import("@assets/icons/stack")),
  "tick": lazy(() => import("@assets/icons/tick")),
  "youtube": lazy(() => import("@assets/icons/youtube")),
  "double-tick": lazy(() => import("@assets/icons/double-tick")),
  "eye-close": lazy(() => import("@assets/icons/eye-close")),
  "eye": lazy(() => import("@assets/icons/eye")),
  "connect-line": lazy(() => import("@assets/icons/connect-line")),
  "copy": lazy(() => import("@assets/icons/copy")),
  "subscription": lazy(() => import("@assets/icons/subscription")),
  "paper-plane": lazy(() => import("@assets/icons/paper-plane")),
  "pilot": lazy(() => import("@assets/icons/pilot")),
  "menu": lazy(() => import("@assets/icons/menu")),
  "sign-out": lazy(() => import("@assets/icons/sign-out")),
  "next": lazy(() => import("@assets/icons/next")),
  "reports": lazy(() => import("@assets/icons/reports")),
  "spotter-black": lazy(() => import("@assets/icons/spotter-black")),
  "drag-handler": lazy(() => import("@assets/icons/drag-handler")),
  "upload": lazy(() => import("@assets/icons/upload")),
  "dot-menu": lazy(() => import("@assets/icons/dot-menu")),
  "portal-lab": lazy(() => import("@assets/icons/portal_lab")),
  "pages": lazy(() => import("@assets/icons/pages")),
  "navigation": lazy(() => import("@assets/icons/navigation")),
  "colors": lazy(() => import("@assets/icons/colors")),
  "banner-hero": lazy(() => import("@assets/icons/banner-hero")),
  "liveboard-area": lazy(() => import("@assets/icons/liveboard-area")),
  "chat-agent": lazy(() => import("@assets/icons/chat-agent")),
  "ai-chat-agent": lazy(() => import("@assets/icons/ai-chat-agent")),
  "kpi": lazy(() => import("@assets/icons/kpi")),
  "drag": lazy(() => import("@assets/icons/drag")),
  "chart": lazy(() => import("@assets/icons/chart")),
  "employees": lazy(() => import("@assets/icons/employees")),
  "content-block": lazy(() => import("@assets/icons/content-block")),
  "image": lazy(() => import("@assets/icons/image")),
  "canvas": lazy(() => import("@assets/icons/canvas")),
  "arrow-down": lazy(() => import("@assets/icons/arrow-down")),
  "arrow-up": lazy(() => import("@assets/icons/arrow-up")),
  "home": lazy(() => import("@assets/icons/home")),
  "headquarters": lazy(() => import("@assets/icons/headquarters")),
  "content": lazy(() => import("@assets/icons/content")),
  "databricks_v2": lazy(() => import("@assets/icons/databricks_v2")),
  "postgres": lazy(() => import("@assets/icons/postgres")),
  "tick_v2": lazy(() => import("@assets/icons/tick_v2")),
  "shield": lazy(() => import("@assets/icons/shield")),
  "idea": lazy(() => import("@assets/icons/idea")),
  "founded": lazy(() => import("@assets/icons/founded")),
  "funding-stage": lazy(() => import("@assets/icons/funding-stage")),
  "monetisation": lazy(() => import("@assets/icons/monetisation")),
  "zoom": lazy(() => import("@assets/icons/zoom")),
  "linkedin": lazy(() => import("@assets/icons/linkedin")),
  "x": lazy(() => import("@assets/icons/x")),
  "instagram": lazy(() => import("@assets/icons/instagram")),
  "facebook": lazy(() => import("@assets/icons/facebook")),
  "open-url-box": lazy(() => import("@assets/icons/open-url-box")),
  "search": lazy(() => import("@assets/icons/search")),
  "sort-order": lazy(() => import("@assets/icons/sort-order")),
  "checkbox-unchecked": lazy(() => import("@assets/icons/checkbox-unchecked")),
  "checkbox-checked": lazy(() => import("@assets/icons/checkbox-checked")),
};
